import React from 'react';

export default class Auth extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuth: false,
      user: '',
      password: ''
    };
  }

  authenticate = () => {
    const body = createFormEncodedBody({
      user: this.state.user,
      password: this.state.password
    });

    const request = window.ui.getConfigs().requestInterceptor({
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body
    });

    fetch('/v3.0/login', request).then(response => {
      if (response.status === 200) {
        this.setState({ isAuth: true });
      } else {
        response.text().then(text => alert(`Authentication failed.\n${text}`));
      }
    });
  };

  onLoginChange = e => {
    let {
      target: { value }
    } = e;
    this.setState({ user: value });
  };

  onPasswordChange = e => {
    let {
      target: { value }
    } = e;
    this.setState({ password: value });
  };

  onLogout = () => {
    fetch('/v3.0/logout', { method: 'post' });
    window.location.reload();
  };

  render() {
    return this.state.isAuth ? this.renderLogout() : this.renderLoginForm();
  }

  renderLoginForm() {
    let { getComponent } = this.props;
    const Button = getComponent('Button');

    return (
      <div className="auth-wrapper">
        <input
          placeholder="User"
          type="text"
          value={this.state.user}
          onChange={this.onLoginChange}
        />
        <input
          placeholder="Password"
          type="password"
          value={this.state.password}
          onChange={this.onPasswordChange}
        />
        <Button className="logout-button" onClick={this.authenticate}>
          Log In
        </Button>
      </div>
    );
  }

  renderLogout() {
    let { getComponent } = this.props;
    const Button = getComponent('Button');

    return (
      <div className="auth-wrapper">
        <Button className="logout-button" onClick={this.onLogout}>
          Log out
        </Button>
      </div>
    );
  }
}

function createFormEncodedBody(auth) {
  const formBody = [];
  for (var property in auth) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(auth[property]);
    formBody.push(encodedKey + '=' + encodedValue);
  }
  return formBody.join('&');
}



// WEBPACK FOOTER //
// ./src/plugins/topbar/auth.jsx